import { hexToRgb } from '@website/common/utils'

export default {
  DARK: {
    border: () => 'none',
    shadow: () => 'none',
    buttonShadow: () => 'none',
    raisedShadow: () => 'none',
    heading: p => p.accentWhite,
    label: p => p.accentWhite,
    background: p => p.tertiaryDark,
    backgroundColor: p => p.tertiaryDark,
    cardBackgroundGradient: p => `rgba(${hexToRgb(p.tertiaryDark)}, 0.5)`,
    border: p => `rgba(${hexToRgb(p.accentWhite)}, 0.2)`,
    socialIcons: p => p.accentWhite
  },
  LIGHT: {
    heading: p => p.primaryDark,
    label: p => p.tertiaryDark,
    background: p => p.tertiaryLight,
    backgroundColor: p => p.tertiaryLight,
    cardBackgroundGradient: p => `rgba(${hexToRgb(p.tertiaryLight)}, 0.4)`,
    border: p => `rgba(${hexToRgb(p.tertiaryDark)}, 0.2)`,
    socialIcons: p => p.primaryDark
  },
  EXTRALIGHT: {
    heading: p => p.tertiaryDark,
    label: p => p.tertiaryDark,
    background: p => p.tertiaryExtraLight,
    backgroundColor: p => p.tertiaryExtraLight,
    cardBackgroundGradient: p => `rgba(${hexToRgb(p.tertiaryExtraLight)}, 0.4)`,
    border: p => `rgba(${hexToRgb(p.tertiaryDark)}, 0.2)`,
    socialIcons: p => p.tertiaryDark
  }
}
